import { ApiContext } from "../contexts/ApiContext";
import { useContext } from "react";
import { useQuery } from "react-query";

export function useSitesByCompanyId(companyId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["sitesByCompanyId", companyId],
    queryFn: async () => {
      if (companyId) return await apiContext.siteApis.getSitesByCompanyId(companyId);
    },
  });
}
